import _ from 'lodash';
import { useMemo } from 'react';
import { SelectMenu } from '@scale/scaleui';
import { enumValues } from '@scale/shared/utils';
import { ChatPipelineRoutingSource } from '@scale/shared-types';
import BuilderHint from 'react-scale/corp/components/QM/taskTemplatesEditor/BuilderHint';

interface SourceRoutingReviewLevelBuilderProps {
  name: string;
  existingValue?: string[];
  updateProperty: (arg: string[]) => void;
  required?: boolean;
  hint?: string;
  /** Really an array of {@link ChatPipelineRoutingSource}, but we make do */
  choices?: string[];
}

const SourceRoutingReviewLevelBuilder = ({
  existingValue,
  updateProperty,
  name,
  required,
  hint,
  choices,
}: SourceRoutingReviewLevelBuilderProps) => {
  const allowedChoices = useMemo(
    () =>
      enumValues(ChatPipelineRoutingSource).filter(
        c => _.isUndefined(choices) || choices.includes(c),
      ),
    [choices],
  );
  return (
    <div>
      <label className="block text-sm font-medium leading-6 text-neutral-700">
        {name}
        {required && <span className="text-danger-400">*</span>}
      </label>
      <div className="flex flex-row">
        <SelectMenu
          className="min-w-[135px]"
          options={allowedChoices.map(s => ({
            id: s,
            name: s,
          }))}
          selectedOptionId={existingValue as string[]}
          setSelected={updateProperty}
          multiple
        />
        {hint && <BuilderHint name={name} hint={hint} />}
      </div>
    </div>
  );
};

export default SourceRoutingReviewLevelBuilder;
